import profile from './account/profile';
import business from './account/business';

export default {
  en: {
    title: 'Accounts',
    tooltip: 'List of accounts',
    profile: profile.en,
    business: business.en,
    columns: {
      name: 'Name Business',
      country: 'Country',
      admin: 'Administrator',
    },
    form: {
      name: {
        label: 'Business name',
        help: 'Enter legal business name',
        error: 'Please provide a business name',
      },
      dni: {
        label: 'TIN',
        help: 'National Taxpayer Identification',
        error: 'Please provide business ID tax.',
      },
      address: {
        label: 'Tax Address',
        help: 'Fill with the current country, not the main headquarters.',
      },
      country: {
        label: 'Country',
        help: 'Select the country not the main headquarters.',
        error: 'Please select a country',
      },
      type: {
        label: 'Type of account',
        help: 'This set the type of account, has different privileges',
        error: 'Please select the type of account',
      },
      lang: {
        label: 'Default language',
        help: 'This is the default language for the account and users. Also code detect automatically the language.',
        error: 'Please select the default language of account',
      },
      integration: {
        label: 'Integration',
        help: 'This is the videoconference provider with which the account will operate.',
        error: 'Please select the integration of account',
      },
      timezone: {
        label: 'Timezone',
        help: 'Timezone where is the business.',
        error: 'Please select the timezone of business',
      },
      firstname: {
        label: 'First name',
        error: 'Please provide a first name for administrator.',
      },
      lastname: {
        label: 'Last name',
        error: 'Please provide a last name for administrator',
      },
      email: {
        label: 'Email administrator',
        help: 'Need valid email and is mandatory for administrator because system send mail activation.',
        error: 'Please add valid email this is very important',
      },
      subscriptions: {
        name: {
          label: 'Name of subscription',
          help: 'Provide a name for customer can identify the contract. Ex. Annual Videsk Contract',
          error: 'Please provide name of subscriptions',
        },
        qty: {
          label: 'Quantity',
          help: 'Select the number of licenses to activate',
          error: 'Please provide the number of licences',
        },
        contract: {
          label: 'Contract',
          help: 'This is the period type of contract. Ex. Annual',
          error: 'Please select the type of contracts',
        },
        level: {
          label: 'Level',
          help: 'This is level of licences to activate.',
          error: 'Please select the level of licences.',
        },
        expire: {
          label: 'Expiration',
          help: 'Date when the licences expire',
          error: 'Please select the expiration date of licenses',
        },
      },
    },
    notification: {
      success: {
        created: 'The account was created. The system send email to {email} with a link for account activation.',
      },
      fail: {
        created: 'Something went wrong, please try again later',
      },
    },
    buttons: {
      subscriptions: 'Add subscriptions',
    },
  },
  es: {
    title: 'Cuentas',
    tooltip: 'Listado de cuentas',
    profile: profile.es,
    business: business.es,
    columns: {
      name: 'Nombre empresa',
      country: 'País',
      admin: 'Administrador',
    },
    form: {
      name: {
        label: 'Nombre de empresa',
        help: 'Ingrese nombre legal de la empresa',
        error: 'Favor de ingresar nombre de la empresa',
      },
      dni: {
        label: 'DNI',
        help: 'Identificación de contribuyente nacional',
        error: 'Proporcione la identificación tributaria nacional.',
      },
      address: {
        label: 'Dirección de facturación',
        help: 'Rellene con el país actual, no la sede principal.',
      },
      country: {
        label: 'País',
        help: 'Seleccione el país, no la sede principal.',
        error: 'Por favor seleccione un país',
      },
      type: {
        label: 'Tipo de cuenta',
        help: 'Esto establece el tipo de cuenta, tiene diferentes privilegios',
        error: 'Por favor seleccione el tipo de cuenta',
      },
      lang: {
        label: 'Idioma predeterminado',
        help: 'Este es el idioma predeterminado para la cuenta y los usuarios. También el código detecta automáticamente el idioma.',
        error: 'Seleccione el idioma predeterminado de la cuenta.',
      },
      integration: {
        label: 'Integración',
        help: 'Este es el proveedor de videoconferencia con el que operará la cuenta.',
        error: 'Por favor seleccione la integración de cuenta',
      },
      timezone: {
        label: 'Zona horaria',
        help: 'Zona horaria donde esta el negocio.',
        error: 'Selecciona una zona horario donde está ubicado el negocio.',
      },
      firstname: {
        label: 'Nombres',
        error: 'Proporcione un nombre para el administrador.',
      },
      lastname: {
        label: 'Apellidos',
        error: 'Proporcione un apellido para el administrador.',
      },
      email: {
        label: 'Correo electrónico',
        help: 'Necesita un correo electrónico válido y es obligatorio para el administrador porque el sistema enviará un enlace de activación al correo.',
        error: 'Agregue un correo electrónico válido, esto es muy importante',
      },
      subscriptions: {
        name: {
          label: 'Nombre de suscripción',
          help: 'Proporcione un nombre para que el cliente pueda identificar el contrato. Ej. Contrato Anual Videsk',
          error: 'Proporcione el nombre de las suscripciones.',
        },
        qty: {
          label: 'Cantidad',
          help: 'Seleccione el número de licencias a activar',
          error: 'Proporcione el número de licencias.',
        },
        contract: {
          label: 'Contrato',
          help: 'Este es el tipo de contrato de periodo. Ej. Anual',
          error: 'Por favor seleccione el tipo de contratos',
        },
        level: {
          label: 'Nivel',
          help: 'Este es el nivel de las licencias a activar. Ej. Administrador',
          error: 'Por favor seleccione el nivel de las licencias.',
        },
        expire: {
          label: 'Expiración',
          help: 'Fecha de caducidad de las licencias.',
          error: 'Seleccione la fecha de vencimiento de las licencias.',
        },
      },
    },
    notification: {
      success: {
        created: 'La cuenta fue creada. El sistema envió un email a {email} con un enlace para la activación de la cuenta.',
      },
      fail: {
        created: 'Algo salió mal, por favor intente nuevamente',
      },
    },
    buttons: {
      subscriptions: 'Añadir suscripciones',
    },
  },
};
